import { DropoffRateOption } from "@redotech/merchant-sdk/rpc/schema/get-dropoff-options";
import { PurchaseLabelType } from "@redotech/merchant-sdk/rpc/schema/purchase-label";
import { useTranslation } from "@redotech/redo-i18n";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";

export const DropoffRate = memo(function DropoffRate({
  option,
  originalLabelCost,
  labelType,
}: {
  option: DropoffRateOption;
  originalLabelCost: number;
  labelType: PurchaseLabelType;
}) {
  const { t } = useTranslation();
  const { formatCurrency } = useContext(CurrencyContext);
  const fee = option.fee ?? 0;

  const difference = Math.max(0, fee - originalLabelCost);
  const differenceString = formatCurrency(difference);

  const showDifferenceView = labelType === PurchaseLabelType.Replace;

  return (
    <Flex dir="row" gap="md" justify="space-between" w="6xl">
      <Flex dir="column" gap="none">
        <Text fontSize="sm" fontWeight="medium">
          {option.providerName}
        </Text>
        {option.fee != null && (
          <Flex align="center" dir="row" gap="sm">
            <Text fontSize="sm" fontWeight="medium">
              {formatCurrency(fee)}
            </Text>
            {showDifferenceView && (
              <Text
                fontSize="sm"
                textColor={difference > 0 ? "error" : "success"}
              >
                {t("({{difference}} difference)", {
                  difference: differenceString,
                })}
              </Text>
            )}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
});
